import createFields from './createFields';
import plain from './structure/plain';

export default createFields(plain);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/Fields.js
// module id = 1901
// module chunks = 1